// import React, { useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import { blogData } from "../Blog/BlogData"; 
// import {
//   Calendar,
//   User,
//   Facebook,
//   Twitter,
//   Linkedin,
//   ArrowLeft,
//   Scale,
//   MessageSquare,
// } from "lucide-react";
// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";
// import { Helmet } from "react-helmet";

// // COLORS declared at the top as requested
// const COLORS = {
//   bgPrimary: "#0B1C2D",   // Deep Navy
//   bgSecondary: "#13293D", // Slightly Lighter Navy
//   gold: "#C6A75E",        // Premium Gold
//   textLight: "#EAEAEA",
// };

// const BlogDetails = () => {
//   const { blogId } = useParams();
//   const blog = blogData.find((b) => b.id === blogId);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [blogId]);

//   if (!blog) {
//     return (
//       <div className="py-40 text-center font-serif" style={{ backgroundColor: COLORS.bgPrimary, color: COLORS.textLight }}>
//         <h2 className="text-3xl mb-4">Article Not Found</h2>
//         <Link to="/blogs" style={{ color: COLORS.gold }} className="underline">
//           Back to Insights
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>{blog.title} | Shailendra Kumar Singh Advocates & Solicitors</title>
//         <meta name="description" content={blog.excerpt} />
//         <meta name="author" content={blog.author} />
//         <meta property="og:title" content={blog.title} />
//         <meta property="og:image" content={blog.image} />
//       </Helmet>
      
//       <Header />

//       <div className="pt-32 pb-20 overflow-hidden min-h-screen" style={{ backgroundColor: COLORS.bgPrimary }}>
//         <div className="max-w-7xl mx-auto px-6">
          
//           {/* Back Navigation */}
//           <Link
//             to="/blogs"
//             className="group inline-flex items-center gap-2 mb-10 font-sans uppercase text-[10px] font-bold tracking-[3px] transition-all"
//             style={{ color: COLORS.gold }}
//           >
//             <ArrowLeft size={16} className="group-hover:-translate-x-2 transition-transform" />
//             Back to Legal Insights
//           </Link>

//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
//             {/* LEFT COLUMN: Main Article */}
//             <div className="lg:col-span-8">
//               <header className="mb-12">
//                 <div className="flex items-center gap-3 mb-6">
//                   <span 
//                     className="px-4 py-1.5 text-[10px] font-bold uppercase tracking-[3px]"
//                     style={{ backgroundColor: COLORS.gold, color: COLORS.bgPrimary }}
//                   >
//                     {blog.category}
//                   </span>
//                   <div className="h-[1px] w-12 opacity-30" style={{ backgroundColor: COLORS.gold }}></div>
//                 </div>

//                 <h1 className="text-white text-4xl md:text-6xl font-bold leading-[1.1] mb-10">
//                   {blog.title}
//                 </h1>

//                 <div className="flex flex-wrap items-center gap-8 text-gray-400 text-[11px] border-y border-white/10 py-8 font-sans uppercase tracking-[2px]">
//                   <span className="flex items-center gap-2">
//                     <Calendar size={14} style={{ color: COLORS.gold }} /> {blog.date}
//                   </span>
//                   <span className="flex items-center gap-2 text-white font-bold">
//                     <User size={14} style={{ color: COLORS.gold }} /> By {blog.author}
//                   </span>
//                 </div>
//               </header>

//               {/* Featured Image with Premium Border Detail */}
//               <div className="relative mb-16">
//                 <div 
//                     className="absolute inset-0 border-[1px] translate-x-4 translate-y-4 -z-10 opacity-20"
//                     style={{ borderColor: COLORS.gold }}
//                 ></div>
//                 <img
//                   src={blog.image}
//                   alt={blog.title}
//                   className="w-full h-[550px] object-cover rounded-xl shadow-2xl"
//                 />
//                 <div className="absolute -bottom-10 -right-10 hidden md:block opacity-5">
//                   <Scale size={200} color={COLORS.gold} />
//                 </div>
//               </div>

//               {/* Article Content */}
//               <div className="legal-journal-content-container">
//                 <div
//                   className="article-body-text text-gray-300"
//                   dangerouslySetInnerHTML={{ __html: blog.content }}
//                 />
//               </div>

//               {/* Social Share */}
//               <div className="mt-24 pt-10 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-8">
//                 <div>
//                   <p className="text-white text-xl font-bold mb-2">Shailendra Kumar Singh Advocates</p>
//                   <p className="text-[10px] text-gray-500 uppercase tracking-[2px]">Ensuring Justice Through Expertise</p>
//                 </div>
//                 <div className="flex gap-6">
//                   {[Facebook, Twitter, Linkedin].map((Icon, idx) => (
//                       <Icon key={idx} size={20} className="text-gray-400 hover:text-white transition-all cursor-pointer" />
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* RIGHT COLUMN: Sidebar */}
//             <div className="lg:col-span-4">
//               <div className="sticky top-32 space-y-8">
                
//                 {/* Consultation Card */}
//                 <div 
//                     className="p-10 text-white rounded-2xl shadow-2xl overflow-hidden relative border border-white/5"
//                     style={{ backgroundColor: COLORS.bgSecondary }}
//                 >
//                   <div 
//                     className="absolute top-0 right-0 w-32 h-32 rounded-full -mr-16 -mt-16 opacity-10"
//                     style={{ backgroundColor: COLORS.gold }}
//                   ></div>

//                   <h3 className="text-2xl font-bold mb-6 border-b pb-4 relative z-10" style={{ color: COLORS.gold, borderColor: "rgba(206, 167, 94, 0.2)" }}>
//                     Legal Assistance
//                   </h3>
//                   <p className="text-sm text-gray-400 font-sans mb-10 leading-[1.8] italic relative z-10">
//                     "The law is a profession of words; we ensure your words carry the weight of justice."
//                   </p>

//                   <Link to="/contact-us" className="relative z-10 block">
//                     <button 
//                         className="w-full bg-transparent border-2 font-bold py-5 uppercase text-[10px] tracking-[4px] transition-all duration-500 rounded-xl hover:text-white"
//                         style={{ borderColor: COLORS.gold, color:"#fff" }}
//                         onMouseEnter={(e) => e.target.style.backgroundColor = COLORS.gold}
//                         onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
//                     >
//                       Request Consultation
//                     </button>
//                   </Link>

//                   <div className="mt-12 pt-8 border-t border-white/5 flex flex-col gap-4 text-[11px] font-sans tracking-[1px] text-gray-500">
//                     <p className="flex items-center gap-2"><MessageSquare size={14} style={{ color: COLORS.gold }} /> Confidential Advisory</p>
//                     <p>📍 Saket Court, New Delhi</p>
//                   </div>
//                 </div>

//                 {/* Topics Cloud */}
//                 <div className="p-8 rounded-2xl border border-white/5" style={{ backgroundColor: COLORS.bgSecondary }}>
//                   <h4 className="font-bold text-white mb-6 text-xs uppercase tracking-widest">
//                     Legal Topics
//                   </h4>
//                   <div className="flex flex-wrap gap-2">
//                     {["Family Law", "Criminal Law", "Bail", "Divorce", "RERA"].map((tag) => (
//                       <span
//                         key={tag}
//                         className="text-[9px] border px-4 py-2 uppercase text-gray-400 hover:text-white cursor-pointer transition-all rounded-full"
//                         style={{ borderColor: "rgba(255,255,255,0.1)" }}
//                       >
//                         {tag}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Journal Styling */}
//         <style dangerouslySetInnerHTML={{ __html: `
//             .article-body-text {
//               font-family: 'Inter', sans-serif;
//               line-height: 2;
//               font-size: 1.125rem;
//             }
//             .article-body-text p {
//               margin-bottom: 2rem;
//               opacity: 0.85;
//             }
//             .article-body-text h2 {
//               font-size: 2.5rem;
//               color: white;
//               font-weight: 700;
//               margin: 4rem 0 1.5rem;
//               border-left: 4px solid ${COLORS.gold};
//               padding-left: 20px;
//             }
//             .article-body-text strong {
//               color: ${COLORS.gold};
//               font-weight: 700;
//             }
//             .article-body-text blockquote {
//               margin: 3rem 0;
//               padding: 2.5rem;
//               background: ${COLORS.bgSecondary};
//               border-radius: 1rem;
//               border-left: 4px solid ${COLORS.gold};
//               font-style: italic;
//               font-size: 1.4rem;
//               color: white;
//             }
//             .article-body-text ul {
//               margin-bottom: 2rem;
//             }
//             .article-body-text li {
//               position: relative;
//               padding-left: 1.5rem;
//               margin-bottom: 1rem;
//               list-style: none;
//             }
//             .article-body-text li::before {
//               content: "";
//               position: absolute;
//               left: 0;
//               top: 12px;
//               width: 8px;
//               height: 2px;
//               background: ${COLORS.gold};
//             }
//         `}} />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default BlogDetails;












import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { blogData } from "../Blog/BlogData"; 
import {
  Calendar,
  User,
  Facebook,
  Twitter,
  Linkedin,
  ArrowLeft,
  Scale,
  MessageSquare,
  Bookmark,
  Share2
} from "lucide-react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Helmet } from "react-helmet";

// LUXURY PALETTE: Moving away from "All Black"
const COLORS = {
  bgPrimary: "#FAF9F6",    // Soft Alabaster (Luxury Paper Feel)
  bgSecondary: "#FFFFFF",  // Pure White
  gold: "#B68D40",         // Antique Gold
  textMain: "#1A1A1A",     // Deep Charcoal (Easier to read than black)
  textMuted: "#666666",
};

const BlogDetails = () => {
  const { blogId } = useParams();
  const blog = blogData.find((b) => b.id === blogId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blogId]);

  if (!blog) {
    return (
      <div className="py-40 text-center font-serif bg-[#FAF9F6] text-[#1A1A1A]">
        <h2 className="text-3xl mb-4 italic">Article Not Found</h2>
        <Link to="/blogs" className="text-[#B68D40] uppercase tracking-widest text-xs font-bold border-b border-[#B68D40]">
          Back to Insights
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{blog.title} | Adv. Shailendra Kumar Singh Advocates & Solicitors</title>
          <meta name="description" content={blog.excerpt} />
  <link
    rel="canonical"
    href={`https://skslawgroupsandassociates.com/blogs/${blog.id}`}
  />

      </Helmet>
      
      <Header />

      <div className="pt-32 pb-20 overflow-hidden min-h-screen" style={{ backgroundColor: COLORS.bgPrimary }}>
        <div className="max-w-7xl mx-auto px-6">
          
          {/* 1. MINIMALIST NAVIGATION */}
          <div className="flex justify-between items-center mb-12 border-b border-gray-200 pb-6">
            <Link
                to="/blogs"
                className="group inline-flex items-center gap-2 font-sans uppercase text-[10px] font-bold tracking-[3px] text-[#1A1A1A] transition-all"
            >
                <ArrowLeft size={14} className="group-hover:-translate-x-1 transition-transform text-[#B68D40]" />
                Back to Archive
            </Link>
            <div className="flex gap-4 text-gray-400">
                <Bookmark size={16} className="hover:text-[#B68D40] cursor-pointer transition-colors" />
                <Share2 size={16} className="hover:text-[#B68D40] cursor-pointer transition-colors" />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
            
            {/* 2. MAIN CONTENT AREA */}
            <div className="lg:col-span-8">
              <header className="mb-12">
                <div className="flex items-center gap-4 mb-8">
                  <span className="text-[10px] font-bold uppercase tracking-[4px] text-[#B68D40]">
                    {blog.category}
                  </span>
                  <div className="h-[1px] w-8 bg-gray-300"></div>
                  <span className="text-[10px] font-bold uppercase tracking-[4px] text-gray-400">
                    Legal Insight
                  </span>
                </div>

                <h1 className="text-[#1A1A1A] text-4xl md:text-6xl font-serif font-medium leading-[1.15] mb-10 italic">
                  {blog.title}
                </h1>

                <div className="flex flex-wrap items-center gap-8 text-[#666666] text-[11px] font-sans uppercase tracking-[2px]">
                  <span className="flex items-center gap-2">
                    <Calendar size={14} className="text-[#B68D40]" /> {blog.date}
                  </span>
                  <span className="flex items-center gap-2 text-[#1A1A1A] font-bold">
                    <User size={14} className="text-[#B68D40]" /> By {blog.author}
                  </span>
                </div>
              </header>

              {/* HIGH-END IMAGE DISPLAY */}
              <div className="relative mb-16 group">
                <div className="absolute -inset-4 border border-[#B68D40]/10 rounded-[2rem] translate-x-2 translate-y-2 -z-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-700"></div>
                <div className="relative overflow-hidden rounded-2xl shadow-xl bg-gray-100">
                    <img
                        src={blog.image}
                        alt={blog.title}
                        className="w-full h-[600px] object-cover"
                    />
                </div>
              </div>

              {/* ARTICLE BODY */}
              <div className="legal-journal-content-container">
                <div
                  className="article-body-text text-[#444444]"
                  dangerouslySetInnerHTML={{ __html: blog.content }}
                />
              </div>

              {/* SIGNATURE SECTION */}
              <div className="mt-20 p-10 bg-white border border-gray-100 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-8">
                <div>
                  <h4 className="text-[#1A1A1A] text-lg font-serif italic mb-1">Adv. Shailendra Kumar Singh </h4>
                  <p className="text-[10px] text-[#B68D40] uppercase tracking-[3px] font-bold">Est. 1995 • Professional Integrity</p>
                </div>
                <div className="flex gap-4">
                  {[Facebook, Twitter, Linkedin].map((Icon, idx) => (
                      <div key={idx} className="w-10 h-10 rounded-full border border-gray-100 flex items-center justify-center hover:bg-[#B68D40] hover:text-white transition-all cursor-pointer text-gray-400">
                        <Icon size={16} />
                      </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 3. SIDEBAR: The Luxury Card Style */}
            <div className="lg:col-span-4">
              <div className="sticky top-32 space-y-10">
                
                {/* ADVOCATE CONTACT CARD */}
                <div className="bg-white p-10 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] border border-gray-100 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-[#B68D40]/5 rounded-full -mr-12 -mt-12"></div>
                  
                  <h3 className="text-xl font-serif text-[#1A1A1A] mb-4 border-b border-gray-50 pb-4">
                    Expert <span className="text-[#B68D40]">Advisory</span>
                  </h3>
                  <p className="text-xs text-[#666666] font-sans mb-8 leading-relaxed italic">
                    "Our solicitors provide strategic counsel to navigate the most intricate legal landscapes."
                  </p>

                  <Link to="/contact-us">
                    <button 
                        className="w-full bg-[#1A1A1A] text-white font-bold py-5 uppercase text-[10px] tracking-[3px] transition-all duration-500 rounded-xl hover:bg-[#B68D40] shadow-lg shadow-black/5"
                    >
                      Secure Consultation
                    </button>
                  </Link>

                  <div className="mt-8 pt-8 border-t border-gray-50 space-y-3">
                    <p className="flex items-center gap-2 text-[10px] font-bold text-[#1A1A1A] uppercase tracking-wider">
                        <MessageSquare size={14} className="text-[#B68D40]" /> Private Registry
                    </p>
                    <p className="text-[10px] text-gray-400 uppercase tracking-widest">📍 Saket Court, New Delhi</p>
                  </div>
                </div>

                {/* CATEGORIES / TOPICS */}
                <div className="p-10 bg-white rounded-[2rem] border border-gray-100">
                  <h4 className="text-[10px] font-bold text-[#1A1A1A] mb-6 uppercase tracking-[4px]">
                    Practices
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {["Family Law", "Criminal Defense", "Bail Jurisprudence", "Real Estate"].map((tag) => (
                      <span
                        key={tag}
                        className="text-[9px] border border-gray-100 px-4 py-2 uppercase text-gray-500 hover:text-[#B68D40] hover:border-[#B68D40] cursor-pointer transition-all rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* REFINED JOURNAL STYLING */}
        <style dangerouslySetInnerHTML={{ __html: `
            .article-body-text {
              font-family: 'Inter', sans-serif;
              line-height: 2.1;
              font-size: 1.15rem;
            }
            .article-body-text p {
              margin-bottom: 2rem;
              color: #444;
            }
            .article-body-text h2 {
              font-family: 'Playfair Display', serif;
              font-size: 2.2rem;
              color: #1A1A1A;
              font-style: italic;
              margin: 4rem 0 1.5rem;
              position: relative;
            }
            .article-body-text h2::after {
                content: "";
                display: block;
                width: 40px;
                height: 2px;
                background: ${COLORS.gold};
                margin-top: 10px;
            }
            .article-body-text strong {
              color: #1A1A1A;
              font-weight: 700;
            }
            .article-body-text blockquote {
              margin: 4rem 0;
              padding: 3rem;
              background: #F8F6F2;
              border-radius: 2rem;
              font-family: 'Playfair Display', serif;
              font-style: italic;
              font-size: 1.5rem;
              color: #1A1A1A;
              text-align: center;
              border: 1px solid rgba(182, 141, 64, 0.1);
            }
            .article-body-text ul {
              margin-bottom: 2rem;
              padding-left: 1rem;
            }
            .article-body-text li {
              position: relative;
              padding-left: 2rem;
              margin-bottom: 1.2rem;
              list-style: none;
              color: #555;
            }
            .article-body-text li::before {
              content: "•";
              position: absolute;
              left: 0;
              color: ${COLORS.gold};
              font-weight: bold;
              font-size: 1.5rem;
              line-height: 1;
            }
        `}} />
      </div>

      <Footer />
    </>
  );
};

export default BlogDetails;